export default __webpack_public_path__ + "static/media/ash-front.773981e5.png";